import gql from 'graphql-tag';

// eslint-disable-next-line
export const fetchUserQuery = gql `query UserById($userId: uuid!) {
  user_by_pk(id: $userId) {
    id
    user_name
    email
    first_name
    last_name
    activated_at
    locked_at
    created_at
  }
}`;

export const fetchUserProfile = gql`query GetUserProfile {
  user_profile {
    id
    email
    first_name
    last_name
    locked_at
    activated_at
    role
    phone
    contact_type
    organizations {
      id
      name
      plan_type{
        name
        description
      }
      country
    }
  }
}`;




// WEBPACK FOOTER //
// ./src/store/graphql/queries/user.js